import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '..';

export interface WidgetDataPayload {
  id: string;
  data: WidgetDataItem;
}

export interface WidgetDataItem {
  data: any[];
  total: number;
}

export interface WidgetDataModel {
  allData: { [key: string]: WidgetDataItem };
  filteredData: { [key: string]: WidgetDataItem };
}

// identifier
export const ALL_WIDGET_DATA = 'allWidgetData';

// default state
const initialState: WidgetDataModel = {
  allData: {},
  filteredData: {},
};

//slice
const allWidgetDataSlice = createSlice({
  name: ALL_WIDGET_DATA,
  initialState,
  reducers: {
    setAllWidgetData: (state: WidgetDataModel, action: PayloadAction<WidgetDataPayload>): void => {
      const { id, data } = action.payload;
      state.allData[id] = data;
    },
    clearAllWidgetData: (state: WidgetDataModel): void => {
      Object.assign(state, { allData: {}, filteredData: {} });
    },
    setFilteredWidgetData: (
      state: WidgetDataModel,
      action: PayloadAction<WidgetDataPayload>
    ): void => {
      const { id, data } = action.payload;
      state.filteredData[id] = data;
    },
    removeFilteredWidgetData: (
      state: WidgetDataModel,
      action: PayloadAction<{ id: string }>
    ): void => {
      const { id } = action.payload;
      delete state.filteredData[id];
    },
  },
});

//selectors

export const selectAllWidgetDataById = (state: RootState, id: string): WidgetDataItem | null =>
  (state?.allWidgetData?.allData?.[id] ?? null) as WidgetDataItem | null;

export const selectFilteredWidgetDataById = (state: RootState, id: string): WidgetDataItem | null =>
  (state?.allWidgetData?.filteredData?.[id] ?? null) as WidgetDataItem | null;

//actions
export const {
  setAllWidgetData,
  clearAllWidgetData,
  setFilteredWidgetData,
  removeFilteredWidgetData,
} = allWidgetDataSlice.actions;

//reducer
export default allWidgetDataSlice;
